import { render, staticRenderFns } from "./BillDrawer.vue?vue&type=template&id=e527a6c0&scoped=true"
import script from "./BillDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./BillDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BillDrawer.vue?vue&type=style&index=0&id=e527a6c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e527a6c0",
  null
  
)

export default component.exports